'use client';

import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { ITerm } from '@/constants/TOS';
import { generalTermsAndConditionsOfSale } from '@/constants/Terms';

const SiteTermsOfServicesComponent = () => {
  const renderTextHandler = (item: ITerm) => {
    switch (item.tag) {
      case 'h1':
        return <h1 className="font-sofiaSans fw-bold">{item.text || ''}</h1>;
      case 'h2':
        return <h2 className="font-sofiaSans fw-bold mt-3">{item.text || ''}</h2>;
      case 'h3':
        return <h3 className="font-sofiaSans fw-bold ms-2">{item.text || ''}</h3>;
      case 'h4':
        return <h4 className="font-sofiaSans fw-bold">{item.text || ''}</h4>;
      case 'h5':
        return <h5 className="font-sofiaSans fw-bold ms-3 mt-2">{item.text || ''}</h5>;
      case 'ul':
        return (
          <ul>
            {item?.items?.map((text: string, index: number) => (
              <li key={index} className="font-sofiaSans fs-5 ms-3">
                {text}
              </li>
            ))}
          </ul>
        );
      default:
        return <p className="font-sofiaSans fs-5 ms-3">{item.text || ''}</p>;
    }
  };

  return (
    <Container fluid="xl" className="tw-bg-gradient-to-b tw-from-white tw-via-blue-50/50 tw-to-white">
      <Row className="px-lg-5 mb-5 pt-5">
        <Col className="px-lg-5">
          <Row className="px-lg-5">
            <Col>
              {generalTermsAndConditionsOfSale.map((term: ITerm, index: number) => (
                <Row key={index}>
                  <Col>{renderTextHandler(term)}</Col>
                </Row>
              ))}
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default SiteTermsOfServicesComponent;
